import React from "react";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import { useWindowBehavior } from "../hooks/useWindowBehavior";

// Renders a reusable draggable window shell with shared title-bar behavior.
export const ReusableWindow = ({
  title,
  iconSrc,
  iconAlt,
  children,
  initialPosition = { x: 0, y: 0 },
  className = "",
  onClose,
  onMinimize,
  onMaximize,
}) => {
  const {
    isVisible,
    isMaximized,
    position,
    handleClose,
    handleMinimize,
    handleMaximise,
    handleDrag,
  } = useWindowBehavior({ initialPosition });

  if (!isVisible) {
    return null;
  }

  return (
    <Draggable
      handle=".title-bar"
      bounds="parent"
      disabled={isMaximized}
      position={isMaximized ? { x: 0, y: 0 } : position}
      onDrag={(_, data) => handleDrag(data)}
    >
      <div className={`draggable-window ${isMaximized ? "maximized" : ""} ${className}`.trim()}>
        <div className="window">
          <div className="title-bar">
            <div className="title-bar-text">
              {iconSrc ? (
                <img className="small-icon-image" src={iconSrc} alt={iconAlt || title} />
              ) : null}
              {title}
            </div>
            <div className="title-bar-controls">
              <button aria-label="Minimize" onClick={() => handleMinimize(onMinimize)}></button>
              <button aria-label="Maximize" onClick={() => handleMaximise(onMaximize)}></button>
              <button aria-label="Close" onClick={() => handleClose(onClose)}></button>
            </div>
          </div>
          {children}
        </div>
      </div>
    </Draggable>
  );
};

// Wraps the scanlines experience in the reusable window shell.
export const DraggableWindow = ({ setScanlinesEnabled }) => {
  return (
    <ReusableWindow
      title="Scanlines"
      iconSrc="/msg_information-0.png"
      iconAlt="Scanlines"
    >
      <div className="window-body">
        <p>Do you want to turn on scan lines? </p>
        <button onClick={() => setScanlinesEnabled(true)}>Enable</button>
        <button onClick={() => setScanlinesEnabled(false)}>Disable</button>
      </div>
    </ReusableWindow>
  );
};

ReusableWindow.propTypes = {
  title: PropTypes.string.isRequired,
  iconSrc: PropTypes.string,
  iconAlt: PropTypes.string,
  children: PropTypes.node,
  initialPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  className: PropTypes.string,
  onClose: PropTypes.func,
  onMinimize: PropTypes.func,
  onMaximize: PropTypes.func,
};

DraggableWindow.propTypes = {
  setScanlinesEnabled: PropTypes.func.isRequired,
};
